import { limparSessao, sessaoAtual } from "./auth";

export class SessaoExpiradaError extends Error {}

async function chamar(caminho: string, opcoes?: RequestInit): Promise<Response> {
  const sessao = sessaoAtual();
  const resp = await fetch(caminho, {
    ...opcoes,
    headers: {
      ...(opcoes?.headers || {}),
      Authorization: `Bearer ${sessao?.token || ""}`,
    },
  });
  if (resp.status === 401) {
    limparSessao();
    throw new SessaoExpiradaError("sessao expirada");
  }
  return resp;
}

export async function getJson<T>(caminho: string): Promise<T> {
  const resp = await chamar(caminho);
  if (!resp.ok) throw new Error(`falha na requisicao: ${resp.status}`);
  return resp.json() as Promise<T>;
}

export async function postJson<T>(caminho: string, body?: unknown): Promise<T> {
  const resp = await chamar(caminho, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!resp.ok) throw new Error(`falha na requisicao: ${resp.status}`);
  return resp.json() as Promise<T>;
}

export async function putJson<T>(caminho: string, body?: unknown): Promise<T> {
  const resp = await chamar(caminho, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!resp.ok) throw new Error(`falha na requisicao: ${resp.status}`);
  return resp.json() as Promise<T>;
}

export function conectarWebSocket(onMensagem: (msg: { tipo: string; dado: unknown }) => void): WebSocket {
  const sessao = sessaoAtual();
  const protocolo = location.protocol === "https:" ? "wss:" : "ws:";
  const ws = new WebSocket(`${protocolo}//${location.host}/m5/ws?token=${sessao?.token || ""}`);
  ws.onmessage = (ev) => {
    try {
      onMensagem(JSON.parse(ev.data));
    } catch {
      // ignora mensagem invalida
    }
  };
  return ws;
}
